import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=f394d788&scoped=true"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=f394d788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f394d788",
  null
  
)

export default component.exports